/**
 * Replace spaces around commas
 * @param {String} input
 * @returns {String}
 */
const replaceCommas = (input) => {
  if (input.includes(",")) {
    return input.replace(/\s*,\s*/g, ",");
  } else {
    return input;
  }
};

export default replaceCommas;
